import React from 'react';
import { StyleProp, StyleSheet, View, ViewStyle } from 'react-native';
import HairLineDivider from 'shared/components/vxl/divider/HairlineDivider/HairLineDivider';
import ListItem, {
  ListItemProps,
} from 'shared/components/vxl/ListItem/ListItem';
import theme from 'shared/styles/theme';

export interface ListItemGroupItem extends ListItemProps {
  keyId?: string | number;
}

export interface ListItemGroupProps {
  items: ListItemGroupItem[];
  containerStyle?: StyleProp<ViewStyle>;
}

const ListItemGroup = ({ items, containerStyle }: ListItemGroupProps) => {
  return (
    <View style={[styles.container, containerStyle]} testID="list-item-group">
      {items.map((itemProps, index) => (
        <React.Fragment key={itemProps.keyId || itemProps.primaryCopy}>
          <ListItem {...itemProps} />
          {index < items.length - 1 ? (
            <View style={styles.hairLineDivider}>
              <HairLineDivider />
            </View>
          ) : null}
        </React.Fragment>
      ))}
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    backgroundColor: theme.color.background.primary,
  },
  hairLineDivider: {
    paddingHorizontal: theme.spacing.m,
  },
});

export default ListItemGroup;
